import { Navigate, Route, Routes } from 'react-router-dom';
import { getToken } from './lib/api';
import AuthPage from './pages/AuthPage';
import DeskPage from './pages/DeskPage';
import AdminPage from './pages/AdminPage';
import HelpPage from './pages/HelpPage';
import LegalPage from './pages/LegalPage';

function RequireAuth({ children }: { children: React.ReactNode }) {
  if (!getToken()) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<AuthPage />} />
      <Route path="/admin" element={<AdminPage />} />
      {/* Public knowledge base — static content only; desk stays behind RequireAuth. */}
      <Route path="/help" element={<HelpPage />} />
      {/* Public legal pages for WEEX OAuth / security review (Privacy + Terms URLs). */}
      <Route path="/privacy" element={<LegalPage />} />
      <Route path="/terms" element={<LegalPage />} />
      <Route path="/" element={<RequireAuth><DeskPage /></RequireAuth>} />
      {/* Unknown paths → auth gate (never DeskPage without token). */}
      <Route path="*" element={<Navigate to={getToken() ? '/' : '/login'} replace />} />
    </Routes>
  );
}
